import React from 'react'
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Button from '@material-ui/core/Button';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Typography, Checkbox, Box, CircularProgress } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';
import Service from '../../config/networkutils';
import CloseIcon from '@material-ui/icons/Close';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import { weekStartDates } from '../../utils/betweenDates';
import { roles_crm_emp, prp_roles_api, prp_roles_api_bulk_update } from '../../config/apiList';
import { getCookie } from '../../utils/CookieHelper';
import Tooltip from "@material-ui/core/Tooltip";
import { LoopCircleLoading } from 'react-loadingg';
import { withSnackbar } from "notistack";
import { ArchiveOutlined } from '@material-ui/icons';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import { Autocomplete } from '@material-ui/lab';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { getDataIsdeletedFalse, getPrimaryColor } from '../Helper/CommonThings';
import ListAltIcon from '@material-ui/icons/ListAlt';

const token = getCookie("ptd_ts_token");

const useStyle = (theme) => ({
  customGridStyle: {
    margin: 0,
    paddingRight: '8px',
    paddingLeft: '16px',
    marginBottom: '16px'
  },
  date: {
    margin: 0,
    width: '100%',
    'margin-top': '5px'
  },
  formControl: {
    margin: theme.spacing(1),
    width: 200,
    float: 'right'
  },
  rows: {
    backgroundColor: "#EDFAFF",
  },
  actionsSticky: {
    background: "#F8F8F8",
  },
  leftSticky: {
    background: "#F8F8F8",
  },
  headerSticky: {
    background: "#F8F8F8",
  },
  employeeRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E3F2FD',
    },
  }
})

// const validQty = [0.2, 0.4, 0.5, 0.6, 0.8, 1]
class PRPEmpTable extends React.Component {
  constructor(props) {
    super(props);
    this.isUnmounted = false
    this.requestControllers = new Set()
    this.assignInFlight = false
    this.state = {
      columns: [],
      data: [],
      dataLength: 0,
      start_date: '',
      subTabledata: [],
      showDialog: false,
      customQtyValues: this.props?.customQtyValues,
      selectedRole: {},
      selectedEmployee: {},
      isLoading: false,
      addEmpDialog: false,
      allEmpList: [],
      empColumns: [],
      owner_region: {},
      owner_delivery_unit: {},
      sector: {},
      assign_emp_data: {},
      allEmpObj: {},
      combiRoleEmployee: [],
      combiRoleEmployeeCopy: [],
      employeeSearchText: '',
      type: 1,
      archiveAlert: false,
      archive_emp_data: '',
      assignEmployees: [],
      addQtyDisbaled: false,
      selectedData: [],
      workType: [],
      isTableLoading: true,
      replaceEmployeeStartDate: null,
      replaceEmployee: null,
      replaceEmployeeDialog: false,
      replaceDisabled: false
    }
  }

  componentDidMount() {
    this.isUnmounted = false
    let allEmp = [];
    allEmp = this.props.employees

    this.getLinkedRolesForWorkType()

    this.setState({
      allEmpList: allEmp,
      owner_delivery_unit: this.props.owner_delivery_unit,
      owner_region: this.props.owner_region,
      sector: this.props.sector
    }, () => {
      this.getModifiedData(this.props.roleData.prp_role)
    })
  }

  componentWillUnmount() {
    this.isUnmounted = true
    this.cancelPendingRequests()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedEmployees !== this.props.selectedEmployees ||
      prevProps.roleData !== this.props.roleData
    ) {
      this.getModifiedData(this.props.roleData.prp_role)
    }
  }

  createRequestController = () => {
    if (typeof AbortController === 'undefined') {
      return null
    }
    const controller = new AbortController()
    this.requestControllers.add(controller)
    return controller
  }

  clearRequestController = (controller) => {
    if (controller) {
      this.requestControllers.delete(controller)
    }
  }

  cancelPendingRequests = () => {
    this.requestControllers.forEach((controller) => {
      try {
        controller.abort()
      } catch (error) {
        // no-op
      }
    })
    this.requestControllers.clear()
  }

  getUpdatedInfoText = (employeeRow, fallbackUpdatedInfo = '') => {
    if (employeeRow?.updated_info) {
      return employeeRow.updated_info
    }

    const updatedBy = employeeRow?.updated_by || 'N/A'
    const rawDate = employeeRow?.updated_on || 'N/A'
    const formattedDate = rawDate && moment(rawDate).isValid() ? moment(rawDate).format('DD-MM-YYYY HH:mm') : 'N/A'
    if (updatedBy !== 'N/A' || formattedDate !== 'N/A') {
      return `Name: ${updatedBy}\nDate: ${formattedDate}`
    }

    return fallbackUpdatedInfo || 'Name: N/A\nDate: N/A'
  }

  getModifiedData(prp_role) {
    const data = Array.isArray(prp_role) ? prp_role : [];
    let data2 = []
    const existingUpdatedInfoById = this.state.data.reduce((acc, row) => {
      if (row?.id) {
        acc[row.id] = row.updated_info || ''
      }
      return acc
    }, {})
    data.forEach((rowItem) => {
      const ele = { ...rowItem }
      if (this.props.selectedEmployees.length > 0) {
        let find = this.props.selectedEmployees.find(role => role.role_id === ele.role_id && role.id === ele.id)
        if (find) {
          ele['is_checked'] = true;
        } else {
          ele['is_checked'] = false
        }
      } else {
        ele['is_checked'] = false
      }

      let set = []
      let totalWeeks = 0;

      for (const item in ele.dates) {
        set.push(item)
        if (moment(item, 'DD/MM/YYYY').isValid()) {
          totalWeeks = Number(totalWeeks) + Number(ele.dates[item])
        }
      }
      ele['total_weeks'] = totalWeeks.toFixed(1)
      let sorted = set.sort(function (a, b) {
        a = a.toString().split('/');
        b = b.toString().split('/');
        return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
      });
      let allDatesQty = { ...ele, ...(ele.dates || {}) }
      allDatesQty.updated_info = this.getUpdatedInfoText(ele, existingUpdatedInfoById[ele.id])


      let st_en_date = { start_date: sorted[0], end_date: sorted[sorted.length - 1] }
      allDatesQty = { ...allDatesQty, ...st_en_date }

      data2.push(allDatesQty)
    })
    this.setState({
      data: data2,
      isLoading: false
    })
  }

  addCustomField = () => {
    let fileds = [...this.state.customQtyValues]
    let obj = {
      from: this.props.project.contractor_start_date,
      to: this.props.project.contractor_end_date,
      qty: '',
      error: false,
      errorMsg: ''
    }
    fileds.push(obj)
    this.setState({ customQtyValues: fileds })
  }

  open() {
    this.openDialog()
  }

  dialogFunc() {
    this.openDialog()
  }

  openDialog = () => {
    this.setState({ showDialog: true })
  }

  closeDialog = () => {
    this.setState({ showDialog: false })
  }

  replaceEmpList() {
    const controller = this.createRequestController()
    this.setState({ replaceEmployeeDialog: true, isTableLoading: true })
    let url = `/api/prp/rolenew/get_customized_emps_list/?crm=${this.props.project.id ? this.props.project.id : this.props.project.crm_id}&filter_type=others&archive_reason=0&role=${this.props.roleData?.role_id}`
    Service.get(url, {
      signal: controller ? controller.signal : undefined,
      headers: {
        Authorization: "Token " + token,
      },
    })
      .then(res => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
        let resData = getDataIsdeletedFalse(res.data)
        var ids = resData.map(emp => emp.id)
        var searchKeyByEmployeeId = resData.reduce((acc, emp) => {
          acc[emp.id] = emp.search_key
          return acc
        }, {})
        var empList = []
        empList = this.props.employees
          .filter(emp => ids.includes(emp.id))
          .map(emp => ({ ...emp, search_key: searchKeyByEmployeeId[emp.id] }))
        console.log(empList)
        this.setState({ combiRoleEmployee: empList, combiRoleEmployeeCopy: empList, employeeSearchText: '', isTableLoading: false })
      })
      .catch(error => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
        this.setState({ isTableLoading: false })
        console.log(error)
        this.props.enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      });
  }

  addEmpDialogOpen = () => {
    const controller = this.createRequestController()
    this.setState({ addEmpDialog: true, isTableLoading: true })
    let url = `/api/prp/rolenew/get_customized_emps_list/?crm=${this.props.project.id ? this.props.project.id : this.props.project.crm_id}&filter_type=others&archive_reason=0&role=${this.props.roleData?.role_id}`
    Service.get(url, {
      signal: controller ? controller.signal : undefined,
      headers: {
        Authorization: "Token " + token,
      },
    })
      .then(res => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
        let resData = getDataIsdeletedFalse(res.data)
        var ids = resData.map(emp => emp.id)
        var searchKeyByEmployeeId = resData.reduce((acc, emp) => {
          acc[emp.id] = emp.search_key
          return acc
        }, {})
        var empList = []
        empList = this.props.employees
          .filter(emp => ids.includes(emp.id))
          .map(emp => ({ ...emp, search_key: searchKeyByEmployeeId[emp.id] }))
        console.log(empList)
        this.setState({ combiRoleEmployee: empList, combiRoleEmployeeCopy: empList, employeeSearchText: '', isTableLoading: false })
      })
      .catch(error => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
        this.setState({ isTableLoading: false })
        console.log(error)
        this.props.enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      });
    // let roleId;
    // this.props.prpData.forEach(ele => {
    //   if (ele.id === this.state.assign_emp_data.prp) {
    //     roleId = ele.role
    //   }
    // })
    // let role = this.props.allRoles[roleId];
    // let combiRole = ''


    // // this.props.roles.forEach(role => {
    // //     if(roleId === role.id){
    // //         combiRole = role.current_combi_role
    // //     }
    // // })

    // for (let i = 0; i < this.props.roles.length; i++) {
    //   if (role === this.props.roles[i].job_roles) {
    //     combiRole = this.props.roles[i].current_combi_role;
    //     break;
    //   }
    // }

    // let combinedCombiRoles = [];
    // for (let i = 0; i < this.props.roles.length; i++) {
    //   if (combiRole === this.props.roles[i].current_combi_role) {
    //     combinedCombiRoles.push(this.props.roles[i].id)
    //   }
    // }


    // let combiRoleEmps = [];
    // this.state.allEmpList.forEach(emp => {
    //   // filter combi role
    //   if (combinedCombiRoles.includes(emp.job_title)) {
    //     combiRoleEmps.push(emp)
    //   }
    //   if (emp.global_assign === 1) {
    //     combiRoleEmps.push(emp)
    //   }
    // })

    // combiRoleEmps = combiRoleEmps.filter(emp => !emp.end_date || moment(emp.end_date).isAfter(moment().format()))


    // this.setState({ combiRoleEmployee: combiRoleEmps }, () => {
    //   this.setState({ addEmpDialog: true })
    // })
  }

  addEmpDialogClose = () => {
    this.setState({ addEmpDialog: false, prp_id: null })
  }

  filterEmployeesBySearchKey = (searchText = '') => {
    const searchKey = searchText.trim().toLowerCase()
    const employeeList = this.state.combiRoleEmployeeCopy
    const filteredEmployees = searchKey
      ? employeeList.filter(employee => {
        const employeeSearchKey = employee.search_key && typeof employee.search_key === 'object'
          ? Object.values(employee.search_key).join(' ')
          : employee.search_key || ''
        return employeeSearchKey.toLowerCase().includes(searchKey)
      })
      : employeeList

    this.setState({ employeeSearchText: searchText, combiRoleEmployee: filteredEmployees })
  }

  getLinkedRolesForWorkType() {
    const controller = this.createRequestController()
    Service.get('/api/role/worktype/role_work_type_link/', {
      signal: controller ? controller.signal : undefined,
      headers: {
        Authorization: "Token " + token,
      },
    }).then(res => {
      this.clearRequestController(controller)
      if (this.isUnmounted) {
        return
      }
      let obj = []
      for (let index = 0; index < res.data.length; index++) {
        const element = res.data[index];
        if (element.linked_role_ids.length !== 0) {
          for (let index = 0; index < element.linked_role_ids.length; index++) {
            const element1 = element.linked_role_ids[index];
            if (element1.role_id === this.props.roleData.role) {
              obj.push(element)
            }
          }
        }
      }
      this.setState({ workType: obj })
    }).catch(error => {
      this.clearRequestController(controller)
      if (this.isUnmounted) {
        return
      }
      console.log(error)
      this.props.enqueueSnackbar('Something went wrong!', {
        variant: 'error'
      });
    })
  }

  fetchOps() {
    // this.setState({ isLoading: true })
    const controller = this.createRequestController()
    Service.get(roles_crm_emp + "?is_archive=0&role=" + this.props.roleData.role_id + "&crm=" + this.props.project.id, {
      signal: controller ? controller.signal : undefined,
      headers: {
        Authorization: "Token " + token,
      },
    })
      .then(res => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
        let data = [];
        data = getDataIsdeletedFalse(res.data);
        let data2 = []
        const existingUpdatedInfoById = this.state.data.reduce((acc, row) => {
          if (row?.id) {
            acc[row.id] = row.updated_info || ''
          }
          return acc
        }, {})
        data.forEach(ele => {
          if (this.props.selectedEmployees.length > 0) {

            // this.props.roleIdArray.map(role => {
            //   if (role.role_id === ele.role_id &&  role.id === ele.id) {
            //     ele['is_checked'] = true;
            //     break
            //   }else{
            //     ele['is_checked'] = false
            //   }
            // })

            let find = this.props.selectedEmployees.find(role => role.role_id === ele.role_id && role.id === ele.id)
            if (find) {
              ele['is_checked'] = true;
            } else {
              ele['is_checked'] = false
            }

          } else {
            ele['is_checked'] = false
          }


          let set = []
          let totalWeeks = 0;

          for (const item in ele.dates) {
            set.push(item)
            if (moment(item, 'DD/MM/YYYY').isValid()) {
              totalWeeks = Number(totalWeeks) + Number(ele.dates[item])
            }
          }
          ele['total_weeks'] = totalWeeks.toFixed(1)
          let sorted = set.sort(function (a, b) {
            a = a.toString().split('/');
            b = b.toString().split('/');
            return a[2] - b[2] || a[1] - b[1] || a[0] - b[0];
          });
          let allDatesQty = { ...ele, ...ele.dates }
          allDatesQty.updated_info = this.getUpdatedInfoText(ele, existingUpdatedInfoById[ele.id])


          let st_en_date = { start_date: sorted[0], end_date: sorted[sorted.length - 1] }
          allDatesQty = { ...allDatesQty, ...st_en_date }
          // if (ele.shdl_data) {
          //     ele.shdl_data.forEach((dates, i) => {
          //         let alldates = weekStartDates(dates.from, dates.to);
          //         alldates.forEach(date => {
          //             let qty = dates.qty;
          //             allDatesQty = { ...allDatesQty, [date]: qty }
          //         })4
          //     })
          // }
          data2.push(allDatesQty)
          // let keys = Object.keys(allDatesQty);
          // var last = keys[keys.length - 1];

        })

        this.setState({
          data: data2,
          dataLength: data2.length,
          // isLoading: false
          // columns: this.props.column
        })
      })
      .catch(error => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
      })
      .finally(() => {
        if (!this.isUnmounted) {
          this.setState({ isLoading: false })
        }
      })
  }

  handleCustomQty = (e, idx) => {

    let preObj = { ...this.props.customQtyValues[idx] }
    preObj['qty'] = e.target.value;
    let newValues = [...this.props.customQtyValues];
    newValues[idx] = preObj;
    this.setState({ customQtyValues: newValues })
  }

  handleCustomToDate = (date, idx) => {
    let preObj = { ...this.props.customQtyValues[idx] }
    preObj['to'] = moment(date).toISOString();
    let newValues = [...this.props.customQtyValues];
    newValues[idx] = preObj;
    this.setState({ customQtyValues: newValues })
  }

  handleCustomFromDate = (date, idx, role_id) => {
    let preObj = [...this.props.customQtyValues]
    for (let i = 0; i < preObj.length; i++) {
      if (preObj[i].role_id === role_id) {
        preObj[i]['from'] = moment(date).toISOString();
      }
    }
    // preObj['from'] = moment(date).toISOString();
    let newValues = [...this.props.customQtyValues];
    newValues[idx] = preObj;
    this.setState({ customQtyValues: newValues })
  }

  prpBulkEdit(date, shdl_datas) {
    let newDates = Object.keys(date)
    let data = [...this.props.selectedEmployees]
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      // let keys = Object.keshdl_datasys(element.dates);
      let Quantity = shdl_datas[0].qty
      let obj = {}
      for (let i = 0; i < newDates.length; i++) {
        const element = newDates[i];
        obj[element] = Quantity
      }

      element.dates = obj
      element.shdl_data = shdl_datas
    }

    this.setState({ selectedData: data }, () => {

      Service.patch(prp_roles_api_bulk_update, {
        headers: {
          Authorization: "Token " + token,
        },
        data: this.state.selectedData
      })
        .then(res => {

          this.props.enqueueSnackbar('Updated Successfully', {
            variant: 'success'
          });
          this.setState({ addQtyDisbaled: false, selectedData: [] });
          this.closeDialog()
          this.props.reset()
          this.componentDidMount()

          // resolve({ success: true })
        })
        .catch(e => {
          console.error(e)
          this.props.enqueueSnackbar('Something went wrong!', {
            variant: 'error'
          });
          // reject({ success: false })
        })
    })
  }

  applyCustomQty = () => {
    this.setState({ addQtyDisbaled: true, })
    try {

      let empIdx = null
      for (let i = 0; i < this.state.data.length; i++) {
        const element = this.state.data[i];
        if (this.state.selectedEmployee.id === element.id) {
          empIdx = i
          break
        }
      }
      // let empIdx = this.state.selectedEmployee.id;
      let allEmpData = [...this.state.data];

      let newData = { ...this.state.selectedEmployee };
      let allDatesQty = {};
      let continueToApply = true;
      this.state.customQtyValues.forEach((dates, i) => {
        let alldates = weekStartDates(dates.from, dates.to);

        alldates.forEach((date) => {
          let qty = Number(dates.qty);
          // if (!validQty.includes(qty)) {
          //     dates.error = true;
          //     dates.errorMsg = "Qty must be 0.2, 0.4, 0.5, 0.6, 0.8 or 1";
          //     // return false;
          //     continueToApply = false
          //     // allDatesQty = { ...allDatesQty, [date]: qty.toFixed(2) }
          // }

          // if (qty > 60) {
          //   dates.error = true;
          //   dates.errorMsg =
          //     "Maximun quantity limit is 60. Please add quantity below 60";
          //   continueToApply = false;
          // } else {
          //   dates.error = false;
          //   dates.errorMsg = ""
          // }

          if (date in allDatesQty) {
            qty += Number(allDatesQty[date]);

            // if (qty > 60) {
            //   dates.error = true;
            //   dates.errorMsg =
            //     "Qty value can not be more than 60/week for " + date;
            //   // return false;
            //   continueToApply = false;
            // }
            // allDatesQty = { ...allDatesQty, [date]: qty.toFixed(2) }
          }

          allDatesQty = { ...allDatesQty, [date]: qty.toFixed(1) };
        });
      });




      this.setState({ customQtyValues: this.state.customQtyValues });

      if (!continueToApply) {
        this.setState({ addQtyDisbaled: false })
        return;
      }

      let shdl_datas = [...this.state.customQtyValues]
      shdl_datas.forEach((schdule, schduleIndex) => {
        delete schdule.created_by
        if (!schdule['from']) {
          this.props.enqueueSnackbar("Select from date!", {
            variant: "error",
          });
          return
        }
        if (!schdule['to']) {
          this.props.enqueueSnackbar("Select to date!", {
            variant: "error",
          });
          return
        }
      })
      if (this.props.multipleSelect) {
        this.prpBulkEdit(allDatesQty, shdl_datas)
      } else {
        // this.props.isLoading(true);
        // var id = ''
        // if(this.props.multipleSelect){
        //   for (const key in newData) {

        //     let data = { ...changes[key].newData }
        //     for (const key in data) {
        //         if (moment(key, 'DD/MM/YYYY').isValid()) {
        //             data.dates = { ...data.dates, [key]: data[key] }
        //         }
        //     }
        //     finalChanges.push(data)
        // }
        // }
        // prp_roles_api +  this.state.selectedEmployee.id
        // prp_roles_api_bulk_update
        Service.put(prp_roles_api + this.state.selectedEmployee.id + "/", {
          headers: {
            Authorization: "Token " + token,
          },
          data: {
            shdl_data: this.state.customQtyValues,
            employee: this.state.selectedEmployee.employee,
            dates: allDatesQty,
            type: this.state.type,
            is_deleted: false,
          },
        })
          .then((res) => {
            this.props.enqueueSnackbar("Qty added successfully", {
              variant: "success",
            });
            newData = { ...newData, ...allDatesQty };
            if (empIdx !== null) {
              allEmpData.splice(empIdx, 1, newData)
              this.setState({ data: allEmpData })
            }
            // allEmpData[empIdx] = newData;
            this.setState({ addQtyDisbaled: false });
            this.closeDialog();
            this.props.refreshRoles();

          })
          .catch((error) => {
            console.log(error)
            this.setState({ addQtyDisbaled: false })
            this.props.enqueueSnackbar("Something went wrong!", {
              variant: "error",
            });
          })
          .finally((e) => {
            // this.props.isLoading(false);
            this.fetchOps();
          });
      }
    } catch (e) {
      this.setState({ addQtyDisbaled: false })
    }
  };

  removeCustomQty = (idx) => {

    let data = [...this.state.customQtyValues];
    data.splice(idx, 1);

    this.setState({ customQtyValues: data })
  }

  postOps(data) {
    Service.post(prp_roles_api, {
      headers: {
        Authorization: "Token " + token,
      },
      data: data,
    })
      .then(res => {
        this.setState({ isLoading: false, })
        this.fetchOps();
        this.props.enqueueSnackbar('Resource added successfully', {
          variant: 'success'
        });
      })
      .catch(error => {
        this.setState({ isLoading: false })
        this.props.enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      })
  }

  putOps(data) {
    if (this.assignInFlight) {
      return
    }
    this.assignInFlight = true
    this.setState({ isLoading: true })
    Service.put(prp_roles_api + data.id + "/", {
      headers: {
        Authorization: "Token " + token,
      },
      data,
    })
      .then(res => {
        if (this.isUnmounted) {
          return
        }
        this.addEmpDialogClose()
        this.getSingleRoleData()
        this.props.enqueueSnackbar('Resource assigned to role successfully', {
          variant: 'success'
        });
      })
      .catch(error => {
        if (this.isUnmounted) {
          return
        }
        console.log(error)
        this.setState({ isLoading: false })
      })
      .finally(() => {
        this.assignInFlight = false
        if (!this.isUnmounted) {
          this.setState({ isLoading: false })
        }
      });
  }

  archivePutOps(data) {
    Service.put(prp_roles_api + data.id + "/", {
      headers: {
        Authorization: "Token " + token,
      },
      data,
    })
      .then(res => {

        this.setState({
          archiveAlert: false,
          archive_emp_data: ''
        }, () => this.getSingleRoleData())
        // this.props.refreshRoles()
        this.props.enqueueSnackbar('Employee archived successfully', {
          variant: 'success'
        });
      })
      .catch(error => {
        this.setState({ isLoading: false })
        this.props.enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
        // this.fetchOps();
      });
  }

  deleteOps(data) {
    this.setState({ isLoading: true })
    Service.delete(prp_roles_api + data.id + "/", {
      headers: {
        Authorization: "Token " + token,
      }
    })
      .then(res => {
        this.fetchOps()
        this.props.enqueueSnackbar('Deleted successfully', {
          variant: 'success'
        });
      })
      .catch(error => {
        this.setState({ isLoading: false })
        // this.props.enqueueSnackbar('Something went wrong!', {
        //     variant: 'error'
        // });
        // this.fetchOps();
      });
  }

  isEmptyValue = (value) => {
    if (value === null || value === undefined) {
      return true
    }
    if (typeof value === 'string') {
      return value.trim() === ''
    }
    return false
  }

  tableCellRender(role, columnLabel) {
    // returns a lookup names
    if (columnLabel.field === 'emp_id') {
      if (columnLabel.render) {
        return columnLabel.render(role);
      } else {
        return null
      }
    } else if (columnLabel.render) {
      return columnLabel.render(role);
    }
    else if (columnLabel.field === 'updated_info') {
      const updatedInfo = role[columnLabel.field]
      const firstNameOnly = typeof updatedInfo === 'string'
        ? updatedInfo.replace(/^(\s*Name:\s*)(\S+).*$/im, '$1$2')
        : updatedInfo
      return <div style={{ whiteSpace: 'pre-line' }}>{firstNameOnly}</div>
    }
    else if (columnLabel.field === "type") {
      return columnLabel.lookup[role[columnLabel.field]];
    }
    return role[columnLabel.field];
  }

  selectMultipleEmployees(row) {

    let data = [...this.state.data]
    data.find(x => x.id === row.id).is_checked = !row.is_checked
    this.setState({
      data: data
    }, () => {
      let data = []
      for (let index = 0; index < this.state.data.length; index++) {
        const element = this.state.data[index];
        if (element.is_checked) {
          data.push(element)
        }
      }
      this.setState({
        selectedData: data
      }, () => {
        this.props.selectedData(row)
        // this.addCustomField()
      })
      let disabled = false
      for (let index = 0; index < this.state.data.length; index++) {
        const element = this.state.data[index];
        if (element.is_checked) {
          disabled = true
        }
      }
      if (disabled) {
        this.props.disabled(false)
      } else {
        this.props.disabled(true)
      }
    })

  }

  selectMultiple(row) {
    let data = [...this.state.data]
    data.find(x => x.id === row.id).is_checked = !row.is_checked
    this.setState({
      data: data
    })
    if (this.props.selectedData) {
      this.props.selectedData(row)
    }

  }

  editWorkType(e, row) {
    Service.put(`/api/prp/role/${row.id}/`, {
      headers: {
        Authorization: "Token " + token,
      },
      data: {
        id: row.id,
        work_type: e.target.value,
      },
    })
      .then((res) => {
        this.props.enqueueSnackbar("Work Type Edited Successfully", {
          variant: "success",
        });

      })
      .catch((error) => {
        console.log(error)
        this.props.enqueueSnackbar("Something went wrong!", {
          variant: "error",
        });
      })
      .finally((e) => {
        // this.props.isLoading(false);
        this.fetchOps();
      });
  }

  getSingleRoleData = () => {
    const controller = this.createRequestController()
    Service.get(`/api/prp/template/get_secured_with_role/?crm=${this.props.project.id}&prp_temp=${this.props.roleData.id}`, {
      signal: controller ? controller.signal : undefined,
      headers: {
        Authorization: "Token " + token,
      },
    })
      .then(res => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
        this.getModifiedData(res.data.prp_role)
        if (this.props.getSingleRoleData) {
          this.props.getSingleRoleData(res.data)
        }
      })
      .catch(error => {
        this.clearRequestController(controller)
        if (this.isUnmounted) {
          return
        }
        console.log(error)
        this.props.enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      });
  }

  disableEmpButton(value) {
    this.setState({ addEmployeeDisabled: value })
  }

  replaceEmployee() {
    if (this.state.replaceEmployee === null) {
      this.props.enqueueSnackbar('Select Employee to Replace!', {
        variant: 'warning'
      });
      return
    } else if (this.state.replaceEmployeeStartDate === null) {
      this.props.enqueueSnackbar('Select Start Date!', {
        variant: 'warning'
      });
      return
    } else {
      this.setState({
        replaceDisabled: true
      })
      Service.get(`/api/crm/switch_emp_in_demand/?prp_role=${this.state.selectedEmployee.id}&new_start_date=${moment(this.state.replaceEmployeeStartDate).format('YYYY-MM-DD')}&new_emp=${this.state.replaceEmployee.id}`, {
        headers: {
          Authorization: "Token " + token,
        },
      })
        .then(res => {
          this.setState({
            replaceDisabled: false,
            replaceEmployeeDialog: false,
          })
          this.props.reload(this.props.roleData?.id)
          this.props.enqueueSnackbar('Employee Replaced Successfully!', {
            variant: 'success'
          });

        })
        .catch(error => {
          console.log(error)
          this.setState({
            replaceDisabled: false,
          })
          if (error.status === 403) {
            this.props.enqueueSnackbar(error.data.message, {
              variant: 'warning'
            });
            return
          } else if (error.status === 406) {
            this.props.enqueueSnackbar(error.data.message, {
              variant: 'warning'
            });
            return
          } else {
            this.props.enqueueSnackbar('Something went wrong!', {
              variant: 'error'
            });
          }
        });
    }
  }

  removeEmployee(item) {
    Service.get(`/api/crm/unassign_emp_or_subcontractor/?prp_role=${item.id}`, {
      headers: {
        Authorization: "Token " + token,
      },
    })
      .then(res => {
        this.props.removeEmployeewithoutReload(item.id, this.props.roleData)
        let data = this.state.data
        data.find(x => x.id === item.id).emp_first_name = null
        data.find(x => x.id === item.id).emp_last_name = null
        data.find(x => x.id === item.id).subcontractor_company_name = null
        data.find(x => x.id === item.id).atr_bbuk_number = null
        this.setState({ data: data })
        this.props.enqueueSnackbar('Employee Removed Successfully!', {
          variant: 'success'
        })
      })
      .catch(error => {
        console.log(error)
        this.props.enqueueSnackbar('Something went wrong!', {
          variant: 'error'
        });
      });
  }

  render() {
    let searchParams = new URLSearchParams(window.location.search)

    let currentComponent = searchParams.get("dashboardcomp")
    if (currentComponent === 'Secured') {
      currentComponent = 'l6a_e'
    } else if (currentComponent === 'Unsecured') {
      currentComponent = 'l5a_e'
    }
    // const allRoles = this.props.allRoles
    // const roleId = this.props.roleData.role;
    const { classes } = this.props
    const stickyActionsCellStyle = {
      width: "165px",
      minWidth: "165px",
      maxWidth: "165px",
      position: "sticky",
      left: 0,
      zIndex: 1000,
      backgroundColor: "#F8F8F8",
      boxShadow: "1px 2px 1px #F8F8F8",
      textAlign: "center",
      paddingLeft: "8px",
      paddingRight: "8px",
      boxSizing: "border-box"
    }
    const stickySecondCellStyle = {
      width: "120px",
      minWidth: "120px",
      maxWidth: "120px",
      position: "sticky",
      left: "165px",
      zIndex: 999,
      backgroundColor: "#F8F8F8",
      boxShadow: "1px 2px 1px #F8F8F8",
      textAlign: "center",
      paddingLeft: "8px",
      paddingRight: "8px",
      boxSizing: "border-box"
    }
    const stickyThirdCellStyle = {
      width: "100px",
      minWidth: "100px",
      maxWidth: "100px",
      position: "sticky",
      left: "285px",
      zIndex: 998,
      backgroundColor: "#F8F8F8",
      boxShadow: "1px 2px 1px #F8F8F8",
      textAlign: "center",
      paddingLeft: "8px",
      paddingRight: "8px",
      boxSizing: "border-box"
    }
    const stickyFourthCellStyle = {
      width: "150px",
      minWidth: "150px",
      maxWidth: "150px",
      position: "sticky",
      left: this.state.workType.length > 0 ? "385px" : "285px",
      zIndex: 1001,
      backgroundColor: "#F8F8F8",
      boxShadow: "1px 2px 1px #F8F8F8",
      textAlign: "center",
      paddingLeft: "8px",
      paddingRight: "8px",
      boxSizing: "border-box"
    }
    const dateColumnStyle = {
      width: "100px",
      minWidth: "100px",
      maxWidth: "100px",
      boxSizing: "border-box"
    }
    return (
      <>
        {this.state.isLoading ? <LoopCircleLoading color={getPrimaryColor()} /> :
          <>
            <TableRow className={classes.rows}  >
              <TableCell style={stickyActionsCellStyle} >
                <b>Actions</b>
              </TableCell>

              <TableCell style={stickySecondCellStyle}>
                {/* <b>Schedules</b> */}
              </TableCell>

              {/* <TableCell style={{ width: "30px" }}>
                <b>Assign Employee</b>
              </TableCell> */}

              {this.state.workType.length > 0 ?
                <TableCell style={stickyThirdCellStyle}><b>Work Type</b></TableCell> : null}

              {this.props.columns.map((columnLabel, columnLabelIndex) => (
                <TableCell key={columnLabelIndex}
                  style={columnLabelIndex === 0 ? { ...columnLabel.headerStyle, ...stickyFourthCellStyle, zIndex: 2001 } : ['start_date', 'end_date'].includes(columnLabel.field) ? { ...columnLabel.headerStyle, ...dateColumnStyle } : columnLabel.field === 'updated_info' ? columnLabel.headerStyle : { ...columnLabel.headerStyle, width: "100px" }}>
                  <b>{columnLabel.title}</b>
                </TableCell>
              ))}
            </TableRow>

            {this.state.data.map((row, i) => (
              <TableRow
                key={i}
                className={classes.rows}
                onClick={(e) => {
                  this.setState({ row, empTableOpen: true });
                }}>

                <TableCell style={stickyActionsCellStyle}>
                  <Box display={'flex'} justifyContent='center' alignItems='center'>
                    <IconButton
                      size='small'
                      aria-label="close"
                      onClick={(event) => {
                        this.setState({ archive_emp_data: row }, () => {
                          this.setState({ archiveAlert: true });
                        });
                      }}>
                      <Tooltip title="Archive">
                        <ArchiveOutlined fontSize='small' />
                      </Tooltip>
                    </IconButton>
                    {(row.emp_first_name || row.emp_last_name) || row.subcontractor_company_name || row.atr_bbuk_number ?
                      <IconButton
                        size='small'
                        aria-label="close"
                        onClick={(event) => {
                          this.setState({ archive_emp_data: row }, () => {
                            this.removeEmployee(row)
                          })
                        }}>
                        <Tooltip title="Remove Employee">
                          <RemoveCircleOutlineIcon fontSize='small' />
                        </Tooltip>
                      </IconButton>
                      : null}
                  </Box>
                </TableCell>

                <TableCell style={stickySecondCellStyle}>
                  <Box display='flex' justifyContent='center' alignItems='center'>
                    {row.emp_first_name ?
                      <IconButton
                        size='small'
                        aria-label="Schedule Dates"
                        disabled={this.props.selectedEmployees.length > 0 ? true : false}
                        onClick={(event) => {
                          this.replaceEmpList()
                          this.setState({
                            selectedEmployee: row,
                            replaceEmployeeDialog: true
                          })
                        }} >
                        <Tooltip title="Replace Employee" placement="left-start">
                          <FindReplaceIcon />
                        </Tooltip>
                      </IconButton> : null}
                    <IconButton
                      size='small'
                      aria-label="Schedule Dates"
                      disabled={this.props.selectedEmployees.length > 0 ? true : false}
                      onClick={(event) => {
                        // Do save operation
                        if (row.shdl_data) {
                          this.setState({
                            customQtyValues: row.shdl_data,
                          });
                        }
                        if (this.props.linkedWorkTypeRole) {
                          this.props.linkedWorkTypeRole(row)
                        }
                        this.setState({
                          selectedRole: this.props.roleData,
                          selectedEmployee: row,
                        }, () => {
                          this.props.rowData(row)
                          this.props.openDialog()
                        });
                      }} >
                      <ListAltIcon fontSize='small' />
                    </IconButton>
                    <Tooltip title={row.emp_is_archived ? "Functionality disabled for Archive Employee" : ""} placement="left-start">
                      <Checkbox
                        size='small'
                        checked={row.is_checked}
                        disabled={row.emp_is_archived ? true : false}
                        onChange={() => this.selectMultiple(row)}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                    </Tooltip>
                  </Box>
                </TableCell>

                {/* <TableCell style={{ textAlign: 'center' }}>
                  <IconButton
                    size='small'
                    aria-label="close"
                    disabled={this.state.addEmployeeDisabled}
                    onClick={(event) => {
                      this.setState({ assign_emp_data: row }, () => {
                        this.addEmpDialogOpen();
                      });
                    }} >
                    <Tooltip title="Assign Employee" >
                      <PersonAddIcon fontSize='small' />
                    </Tooltip>
                  </IconButton>
                </TableCell> */}

                {this.state.workType.length > 0 ?
                  <TableCell style={stickyThirdCellStyle}>
                    <FormControl variant="outlined" size="small">
                      <TextField
                        id="wiringorerecting"
                        name="wiringorerecting"
                        value={row.work_type}
                        onChange={(e) => {
                          this.editWorkType(e, row)
                        }}
                        style={{ width: "80px" }}
                        // label="Wiring/Erecting"
                        select
                        variant='outlined'
                        size='small'
                      >
                        {this.state.workType.map((ele, i) => (
                          <MenuItem value={ele.id}>
                            {ele.name}({ele.short_form})
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </TableCell> : null}

                {this.props.columns.map((columnLabel, indx) => (
                  <TableCell
                    key={indx}
                    style={indx === 0 ? { ...columnLabel.headerStyle, ...stickyFourthCellStyle, zIndex: 2000 } : ['start_date', 'end_date'].includes(columnLabel.field) ? { ...columnLabel.headerStyle, ...dateColumnStyle } : columnLabel.field === 'updated_info' ? columnLabel.cellStyle : { ...columnLabel.headerStyle, width: "100px" }}
                  >
                    {this.tableCellRender(row, columnLabel)}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </>
        }

        <Dialog open={this.state.addEmpDialog} onClose={this.addEmpDialogClose} maxWidth={"lg"}>
          <DialogTitle id="form-dialog-title">
            Add Employee
            <IconButton aria-label="close" onClick={this.addEmpDialogClose} style={{ position: 'absolute', top: '5px', right: '20px' }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ padding: 0 }}>
            <TextField
              value={this.state.employeeSearchText}
              onChange={(event) => this.filterEmployeesBySearchKey(event.target.value)}
              placeholder="Search employees"
              variant="outlined"
              size="small"
              style={{ margin: '8px 16px', width: '300px' }}
            />
            <TableContainer style={{ maxHeight: '60vh' }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    {[
                      'Employee No',
                      'First Name',
                      'Last Name',
                      'Email Address',
                      'Role',
                      'Sub Division',
                      'Operations Lead',
                      'Sector',
                      'Start Date',
                      'End Date'
                    ].map((title) => (
                      <TableCell key={title} style={{ fontWeight: 'bold' }}>
                        {title}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.isTableLoading ?
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <CircularProgress size={24} />
                      </TableCell>
                    </TableRow> :
                    this.state.combiRoleEmployee.map((employee) => (
                      <TableRow
                        key={employee.id}
                        className={classes.employeeRow}
                        hover
                        onClick={() => this.putOps({
                          emp_id: employee.id,
                          crm: this.props.project.id,
                          prp: this.props.roleData.id,
                          role: this.props.roleData.role,
                          id: this.state.assign_emp_data.id
                        })}
                      >
                        {[
                          'emp_no',
                          'first_name',
                          'last_name',
                          'email',
                          'role_name',
                          'owner_region_name',
                          'owner_delivery_unit_name',
                          'sector_name',
                          'start_date',
                          'end_date'
                        ].map((field) => (
                          <TableCell key={field}>
                            {['start_date', 'end_date'].includes(field) && employee[field]
                              ? moment(employee[field]).format('DD-MM-YYYY')
                              : employee[field]}
                          </TableCell>
                        ))}
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

          </DialogContent>
          <DialogActions>
            <Button onClick={this.addEmpDialogClose} color="primary" variant='contained' size='small'>Cancel</Button>
            {/* <Button color="primary" onClick={this.postOps}>Add</Button> */}
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.archiveAlert} onClose={() => this.setState({ archiveAlert: false })} maxWidth={"lg"}>
          <DialogTitle id="form-dialog-title">
            Archive
            <IconButton aria-label="close" onClick={() => this.setState({ archiveAlert: false })} style={{ position: 'absolute', top: '5px', right: '20px' }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ padding: 15 }}>

            <Typography style={{ padding: 10 }}>Are you sure to archive</Typography>

          </DialogContent>
          <DialogActions>
            <Button color="primary" variant='contained' size='small' onClick={() => this.setState({ archiveAlert: false })}>Cancel</Button>
            <Button color="primary" variant='contained' size='small' onClick={() => this.archivePutOps({
              id: this.state.archive_emp_data.id,
              is_archive: 1,
              is_deleted: false,
            })}>Archive</Button>
            {/* {this.props.deletePRPAccess[currentComponent] ? <Button color="primary" onClick={() => this.deleteOps({
              id: this.state.archive_emp_data.id,
            })}>Delete</Button> : null} */}
          </DialogActions>
        </Dialog>
        <Dialog open={this.state.replaceEmployeeDialog} onClose={() => this.setState({ replaceEmployeeDialog: false })} maxWidth={"lg"}>
          <DialogTitle id="form-dialog-title">
            Replace Employee
            <IconButton aria-label="close" onClick={() => this.setState({ replaceEmployeeDialog: false })} style={{ position: 'absolute', top: '5px', right: '20px' }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent style={{ padding: 15, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            <Box marginTop={'10px'}>
              <Autocomplete
                options={this.state.combiRoleEmployee}
                getOptionLabel={(option) => option.first_name + ' ' + option.last_name}
                style={{ width: 300 }}
                value={this.state.replaceEmployee}
                onChange={(e, v) => {
                  this.setState({ replaceEmployee: v })
                }}
                renderInput={(params) => <TextField {...params} label="Employee" variant="outlined" />}
              />
            </Box>
            <Box marginTop={'10px'}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  // autoOk
                  clearable
                  format="dd/MM/yyyy"
                  style={{ width: 300 }}
                  label='Start Date'
                  value={this.state.replaceEmployeeStartDate}
                  onChange={(e) => this.setState({ replaceEmployeeStartDate: e })}
                />
              </MuiPickersUtilsProvider>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button color="primary" variant='contained' size='small' onClick={() => this.setState({ replaceEmployeeDialog: false })}>Cancel</Button>
            <Button disabled={this.state.replaceDisabled} color="primary" variant='contained' size='small' onClick={() => this.replaceEmployee()}>Replace</Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

export default withSnackbar(withStyles(useStyle)(PRPEmpTable))